<div class="two-factor-section">
  <div class="two-factor-section__title component-title">
    {{ 'user-profile.security.twoFactor.title' | translate }}
  </div>
  <div class="two-factor-section__card">
    <div class="two-factor-section__content">
      <div class="two-factor-section__info">
        <div class="two-factor-section__subtitle">
          {{ 'user-profile.security.twoFactor.title' | translate }}
        </div>
        <div class="two-factor-section__description component-subtitle">
          {{ 'user-profile.security.twoFactor.description' | translate: { email: userEmail() } }}
        </div>
      </div>
      <mat-slide-toggle
        [checked]="is2FAEnabled()"
        [disabled]="loading()"
        (change)="onToggleChange($event)"
        [hideIcon]="true"
      />
    </div>
  </div>
</div>
